import { API_BASE_URL } from "@/config/apiBaseUrl";

/**
 * Profile photo URL served through the API so it works in production
 * regardless of axios baseURL or the public/storage symlink path.
 */
export function avatarUrlFor(personnelId, version) {
  if (!personnelId) {
    return null;
  }

  const cacheBust =
    version !== undefined && version !== null ? version : Date.now();

  return `${API_BASE_URL}/api/user/avatar/${personnelId}?v=${cacheBust}`;
}
